import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { ELocalStorageKey } from '@/enums/ELocalStorageKey';
import i18n from '@/services/i18n/i18n';
import { LOCAL__user_auth_set_open_page_after_login } from '@/state/user/auth/LOCAL__user_auth_set_open_page_after_login';
import { local_user_settings_upsert } from '@/state/user/settings/local_user_settings_upsert';
import { REMOTE__user_settings_update } from '@/state/user/settings/REMOTE__user_settings_update';
import { DTO__user_settings } from '@shared/dto/+user/user_settings/DTO__user_settings';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { store } from '../state/store';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export async function FN_USER_SETTINGS__update(settings: DTO__user_settings) {
  if (store.getState().slice_user.is_authorized) {
    await store.dispatch(REMOTE__user_settings_update(settings));
  } else {
    store.dispatch(local_user_settings_upsert(settings));
  }

  if (CONSTANTS__client.SUPPORTED_LANGUAGES.includes(settings.regional_language)) {
    localStorage.setItem(ELocalStorageKey.LANGUAGE, settings.regional_language);
    await i18n.changeLanguage(settings.regional_language);
  }
}

export function save_url_to_store_for_redirect_after_auth() {
  const slug = `${location.pathname}${location.search}`;
  store.dispatch(LOCAL__user_auth_set_open_page_after_login(slug));
}

export function set_timeout(callback: TimerHandler, duration_ms: number) {
  return window.setTimeout(callback, duration_ms);
}

export function set_interval(callback: TimerHandler, duration_ms: number) {
  return window.setInterval(callback, duration_ms);
}

export function format_time_for_rented_model(timestamp_ms: number): string {
  const total_seconds = Math.floor(timestamp_ms / 1000);
  const total_minutes = Math.floor(total_seconds / 60);
  const total_hours = Math.floor(total_minutes / 60);
  const days = Math.floor(total_hours / 24);

  let out = '';

  if (total_hours >= 100) {
    out = `${days}d`;
  } else if (total_hours >= 1) {
    const hours = total_hours;
    const minutes = total_minutes % 60;
    out = `${hours}h:${minutes.toString().padStart(2, '0')}m`;
  } else {
    const minutes = total_minutes;
    const seconds = total_seconds % 60;
    out = `${minutes}m:${seconds.toFixed().toString().padStart(2, '0')}s`;
  }

  return out;
}
